<template>
  <div>
    <v-card v-if="load_tab">
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <!-- <v-tabs
        background-color="transparent"
        :icons-and-text="true"
        class="toolbar"
        centered
      > -->
      <v-tabs background-color="brand" slider-color="#C89933" optional icons-and-text="true" class="white-tabs" centered active-class="active">
       
        <v-tab class="normalize font-weight-bold" @click="tab='basic'">
          Personal
          <v-icon>mdi-account</v-icon>
        </v-tab>
        <v-tab class="normalize font-weight-bold" @click="tab='picture'">
          Photo
          <v-icon>mdi-camera-image</v-icon>
        </v-tab>
        <v-tab class="normalize font-weight-bold" @click="tab='qualification'">
          Qualification
          <v-icon>mdi-cast-education</v-icon>
        </v-tab>
        <v-tab class="normalize font-weight-bold" @click="tab='experience'">
          Experience
          <v-icon>mdi-bookmark-plus</v-icon>
        </v-tab>
        <v-tab class="normalize font-weight-bold" @click="tab='research'">
          Research
          <v-icon>mdi-magnify</v-icon>
        </v-tab>
        <v-tab class="normalize font-weight-bold" @click="tab='publication'">
          Publication
          <v-icon>mdi-book-open-variant</v-icon>
        </v-tab>
        <v-tab class="normalize font-weight-bold" @click="tab='awards'">
          Awards
          <v-icon>mdi-trophy-outline</v-icon>
        </v-tab>
        <v-tab class="normalize font-weight-bold" @click="tab='other'">
          Training
          <v-icon>mdi-mother-heart</v-icon>
        </v-tab>
        <v-tab class="normalize font-weight-bold" @click="tab='sub_taught'">
          Subjects Taught
          <v-icon>mdi-mother-heart</v-icon>
        </v-tab>
        <v-tab class="normalize font-weight-bold" @click="tab='medical'">
          Medical
          <v-icon>mdi-stethoscope</v-icon>
        </v-tab>
         <v-tab v-if="org_id!='sbpps'" class="normalize font-weight-bold" @click="tab='account'">
          Account 
          <v-icon>mdi-account-settings</v-icon>
        </v-tab>
        <v-tab class="normalize font-weight-bold" @click="tab='document'">
          Document 
        <v-icon>mdi-file</v-icon>
        </v-tab>
        <v-tab class="normalize font-weight-bold" @click="tab='academic_files'">
          Academic Files
          <v-icon>mdi-folder-file</v-icon>
        </v-tab>
      </v-tabs>
      <v-col cols="12" sm="12" md="12">
        <v-form id="inst_data">
          <v-card-text v-if="tab == 'basic'" class="box">
            <emp-profile-info :instid="instid"></emp-profile-info> 
          </v-card-text>
          <v-card-text v-if="tab == 'picture'" class="box">
              <emp-profile-picture :instid="instid"></emp-profile-picture> 
          </v-card-text>
          <v-card-text v-if="tab == 'qualification'" class="box">
              <emp-profile-qualification :instid="instid"></emp-profile-qualification> 
          </v-card-text>
          <v-card-text v-if="tab == 'experience'" class="box">
              <emp-profile-experience :instid="instid"></emp-profile-experience> 
          </v-card-text>
          <v-card-text v-if="tab == 'research'" class="box">
              <emp-profile-research :instid="instid"></emp-profile-research> 
          </v-card-text>
          <v-card-text v-if="tab == 'publication'" class="box">
              <emp-profile-publication :instid="instid"></emp-profile-publication> 
          </v-card-text>
          <v-card-text v-if="tab == 'awards'" class="box">
              <emp-profile-awards :instid="instid"></emp-profile-awards> 
          </v-card-text>
          <v-card-text v-if="tab == 'other'" class="box">
              <emp-profile-other :instid="instid"></emp-profile-other> 
          </v-card-text>
          <v-card-text v-if="tab == 'sub_taught'" class="box">
              <emp-sub-taught :instid="instid"></emp-sub-taught> 
          </v-card-text>
           <v-card-text v-if="tab == 'medical'" class="box">
              <emp-medical-details :instid="instid"></emp-medical-details> 
          </v-card-text>
           <v-card-text v-if="tab == 'account' && org_id!='sbpps'" class="box">
              <emp-account-details :instid="instid"></emp-account-details> 
          </v-card-text>
          <v-card-text v-if="tab == 'document'" class="box">
              <emp-profile-document :instid="instid"></emp-profile-document> 
          </v-card-text>
          <v-card-text v-if="tab == 'academic_files'" class="box">
              <emp-academic-files :instid="instid"></emp-academic-files> 
          </v-card-text>
        </v-form>
      </v-col>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import moment from "moment";
import EmployeeProfileInfo from './EmployeePersonalinfo'
import EmployeeProfilePicture from './EmployeeProfilePicture'
import EmployeeProfileQualification from './EmployeeQualification'
import EmployeeProfileExperience from './EmployeeExperience'
import EmployeeProfileResearch from './EmployeeResearch'
import EmployeeProfilePublication from './EmployeePublication'
import EmployeeProfileAwards from './EmployeeAwards'
import EmployeeProfileOther from './EmployeeOtherDetails'
import EmployeeMedicalDetails from './EmployeeMedicalDetails'
import EmployeeAccountDetails from './EmployeeAccountDetails'
import EmployeeProfileDocument from './EmployeeProfileDocument'
import EmployeeSubjectsTaught from './EmployeeSubjectsTaught'
import EmployeeAcademicFiles from './EmployeeAcademicFiles'
export default {
    name: "EmployeeProfileInfo",
    name: "EmployeeProfilePicture",
    name: "EmployeeProfileQualification",
    name: "EmployeeProfileExperience",
    name: "EmployeeProfileResearch",
    name: "EmployeeProfilePublication",
    name: "EmployeeProfileAwards",
    name: "EmployeeProfileOther",
    name: "EmployeeMedicalDetails",
    name: "EmployeeAccountDetails",
    name: "EmployeeProfileDocument",
    name: "EmployeeSubjectsTaught",
    name: "EmployeeAcademicFiles",
    components:{
    'emp-profile-info':EmployeeProfileInfo,
    'emp-profile-picture':EmployeeProfilePicture,
    'emp-profile-qualification':EmployeeProfileQualification,
    'emp-profile-experience':EmployeeProfileExperience,
    'emp-profile-research':EmployeeProfileResearch,
    'emp-profile-publication':EmployeeProfilePublication,
    'emp-profile-awards':EmployeeProfileAwards,
    'emp-profile-other':EmployeeProfileOther,
    'emp-medical-details':EmployeeMedicalDetails, 
    'emp-account-details':EmployeeAccountDetails, 
    'emp-profile-document':EmployeeProfileDocument, 
    'emp-sub-taught':EmployeeSubjectsTaught, 
    'emp-academic-files':EmployeeAcademicFiles, 
},
  props: {
    instid: Number,
  },
  data() {
    return {
      tab: "basic",
      load_tab: true,
      inst_data: "",
      category: {},
      religion: {},
      cast: {},
      domacile: {},
      country: {},
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      basicData: true,
      contactData: true,
      relativeData: true,
      critical_edit: false, //check for employee or parent to edit critical field
      snackbar_msg: "",
      color: "",
      snackbar: false,
      pladdress: null,
      org_id:null,
    };
  },
  mounted() {
    this.getData();
    this.org_id = localStorage.getItem("EPS-tenant");
  },
  methods: {
    getData() {
      this.instructor_id = this.instid;
      const formData = {
        instid: this.instid,
      };
      axios
        .post("/RoleManagement/getInstData", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.inst_data = res.data.inst_data;
            let formatDate = moment(this.inst_data.inst_date_of_birth).format(
              "MMMM Do YYYY"
            );
            // alert(formatDate)
            this.inst_data.inst_date_of_birth_in_words = formatDate;
            this.critical_edit = res.data.critical_edit;
          } else {
            alert("Somthing went wrong!!!");
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    profilePicture(){
        this.tab = 'picture'
    },
  },
};
</script>
<style scoped>
.rmargin {
  margin: 1rem !important;
}
.card {
  border: #2c3e50 !important;
}
.card:hover {
  background: #bdc3c7; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #515e6b,
    #bdc3c7
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #515e6b,
    #bdc3c7
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: white !important;
  font-weight: bold !important;
  text-align: center;
  box-shadow: 20px 20px 20px grey !important;
  -webkit-transition: box-shadow 0.3s ease-in !important;
}
.link-icon {
  color: white;
}
.add-plus-icon:hover {
  color: white;
}
linkname {
  color: #2c5364 !important;
}
 .active {
        color: #222222;
        background-color: #ffff;
    }
/* Inactive tabs */
.white-tabs .v-tab {
  color: var(--v-onBrand-base) !important;
}

/* Inactive icons */
.white-tabs .v-tab .v-icon {
  color: var(--v-onBrand-base) !important;
}

/* Active tab background */
.white-tabs .v-tab--active {
  background-color: #ffffff !important;
  color: #1b1b1b !important;
}

/* Active tab icon */
.white-tabs .v-tab--active .v-icon {
  color: #1b1b1b !important;
}

</style>